/**
 * Pre-colored status icons (success/pending/cancelled/error/warning), fixed
 * at 20px.
 * @registry Status icon set for run/job/record state indicators.
 *
 * Ported from `library-m/feedback/icons/StatusIcons`. Prop surface and
 * exports kept identical — none of the icons accept props in the original,
 * so none are added here either.
 */

import {
  IconAlertOctagonFilled,
  IconCancel,
  IconCircleCheckFilled,
  IconCircleDotFilled,
  IconExclamationCircleFilled,
} from '@tabler/icons-react';
import type {FC} from 'react';

export const SuccessIcon: FC = () => {
  return <IconCircleCheckFilled size={20} color="green" />;
};

export const PendingIcon: FC = () => {
  return <IconCircleDotFilled size={20} color="gray" />;
};

export const CancelledIcon: FC = () => {
  return <IconCancel size={20} color="gray" />;
};

export const ErrorIcon: FC = () => {
  return <IconAlertOctagonFilled size={20} color="red" />;
};

export const WarningIcon: FC = () => {
  return <IconExclamationCircleFilled size={20} color="gold" />;
};
